import CommentedAnswer from 'models/CommentedAnswer';
import Form from './Form';

class TPA extends Form {
  obs?: string;
  obsToDpo?: string;
  /**
   * @example `yyyy-MM-dd`
   */
  receiveDate?: string;
  /**
   * @example `yyyy-MM-dd`
   */
  reviewDate?: string;
  companyName?: string;
  contact?: string;
  dpo?: string;
  areaResponsable?: string;

  jsonMaturityQuestions = {
    hasDPO: new CommentedAnswer(),
    hasInventary: new CommentedAnswer(),
    impactAvaliation: new CommentedAnswer(),
    hasPlans: new CommentedAnswer(),
    hasPolicy: new CommentedAnswer(),
    hasControlData: new CommentedAnswer(),
    hasThirdPartyAccess: new CommentedAnswer(),
    hasCompliance: new CommentedAnswer(),
    hasGovernance: new CommentedAnswer(),
    hasComunicationChannel: new CommentedAnswer(),
    hasLegalProcess: new CommentedAnswer(),
    hasIncident: new CommentedAnswer(),
    hasInvestigated: new CommentedAnswer(),
    hasTrainning: new CommentedAnswer(),
  };

  jsonCompanyPosition = {
    collectData: new CommentedAnswer(),
    employerDataHolders: new CommentedAnswer(),
    purposesResult: new CommentedAnswer(),
    decisionImpactTheHolders: new CommentedAnswer(),
    decidePersonalDataCollected: new CommentedAnswer(),
    professionalOpinions: new CommentedAnswer(),
    holdersCollectDataFrom: new CommentedAnswer(),
    directRelationshipTheHolders: new CommentedAnswer(),
    benefitDirectly: new CommentedAnswer(),
    determinesHowDatatreated: new CommentedAnswer(),
    handlePersonalDataContext: new CommentedAnswer(),
    engagingOtherCompanies: new CommentedAnswer(),
  };

  jsonThirdPartyPosition = {
    collectData: new CommentedAnswer(),
    employerDataHolders: new CommentedAnswer(),
    purposesResult: new CommentedAnswer(),
    decisionImpactTheHolders: new CommentedAnswer(),
    decidePersonalDataCollected: new CommentedAnswer(),
    professionalOpinions: new CommentedAnswer(),
    holdersCollectDataFrom: new CommentedAnswer(),
    directRelationshipTheHolders: new CommentedAnswer(),
    benefitDirectly: new CommentedAnswer(),
    determinesHowDatatreated: new CommentedAnswer(),
    handlePersonalDataContext: new CommentedAnswer(),
    engagingOtherCompanies: new CommentedAnswer(),
  };

  jsonContractAvaliation = {
    relevance: new CommentedAnswer(),
    dataMinimization: new CommentedAnswer(),
    transparency: new CommentedAnswer(),
    sensitiveData: new CommentedAnswer(),
    financialData: new CommentedAnswer(),
    monitoringHolders: new CommentedAnswer(),
    newTechnologies: new CommentedAnswer(),
    minorData: new CommentedAnswer(),
    vulnerableData: new CommentedAnswer(),
    criminalData: new CommentedAnswer(),
    profiling: new CommentedAnswer(),
    automatedDecisions: new CommentedAnswer(),
  };
}

export default TPA;

export interface ITPAResult {
  contractRiskResult: {
    /**
     * @example `18.06`
     */
    result: string;
    /**
     * @example 'score-yellow'
     */
    classColor: string;
    impactReport: string;
  };
  thirdPartyPositionResult: string;
  maturityScore: {
    /**
     * @example `18.06`
     */
    result: string;
    /**
     * @example 'score-yellow'
     */
    classColor: string;
  };
  companyPositionResult: string;
}
